import type { ProfileRes } from "@/types/profile";
import { api } from "./axiosInstance";

export const apiGetProfile = async (id: string): Promise<ProfileRes> => {
  try {
    const response = await api.get(`/api/v1/profiles/${id}`);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export type ProfileCreateParams = {
  raw_page_content?: string;
  page_content?: ProfileRes["content"];
  name: string;
  roles_ids?: string[];
  reps_ids?: string[];
  markets_ids?: string[];
  locations_ids?: string[];
  vendor?: string;
  account_representative?: string;
  created_at?: string;
  updated_at?: string;
};

export type ProfileCreateRes = {
  profile_id: string;
};

export const apiPostProfile = async (
  params: ProfileCreateParams
): Promise<ProfileCreateRes> => {
  try {
    const response = await api.post(`/api/v1/profiles`, params);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export type ProfileUpdateParams = {
  id: string;
  params: Partial<ProfileCreateParams>;
};
export type ProfileUpdateRes = string;

export const apiPatchProfile = async ({
  id,
  params,
}: ProfileUpdateParams): Promise<ProfileUpdateRes> => {
  try {
    const response = await api.patch(`/api/v1/profiles/${id}`, params);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const apiUploadProfileImage = async (
  profileId: string,
  imageBlob: Blob
): Promise<string> => {
  const formData = new FormData();
  const extension = imageBlob.type === "image/png" ? "png" : "jpg";
  formData.append("image", imageBlob, `profile-image.${extension}`);
  const response = await api.put(
    `/api/v1/profiles/${profileId}/image`,
    formData,
    { headers: { "Content-Type": "multipart/form-data" } }
  );
  return response.data;
};

export const apiDeleteProfileImage = async (
  profileId: string
): Promise<void> => {
  await api.delete(`/api/v1/profiles/${profileId}/image`);
};

export const apiDeleteProfile = async (id: string) => {
  try {
    await api.delete(`/api/v1/profiles/${id}`);
  } catch (error) {
    throw error;
  }
};
